export default "__VITE_ASSET__RTfdL1Lx__"